import React from "react";
import { MdBuild, MdSchedule } from "react-icons/md";

const MaintenanceMode = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex flex-col justify-center items-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        {/* Logo/Icon Section */}
        <div className="flex justify-center">
          <div className="bg-[#2283FF] p-6 rounded-full shadow-lg">
            <MdBuild className="text-4xl text-white" />
          </div>
        </div>

        {/* Main Content */}
        <div className="space-y-6">
          <div className="space-y-2">
            <h1 className="text-3xl font-bold text-gray-900 sm:text-4xl">
              Under Maintenance
            </h1>
            <p className="text-lg text-gray-600">
              We're currently performing scheduled maintenance
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200">
            <div className="flex items-center justify-center space-x-2 mb-4">
              <MdSchedule className="text-[#2283FF] text-xl" />
              <span className="text-gray-700 font-medium">
                Estimated Duration
              </span>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed">
              Our team is working diligently to improve your experience. We
              expect to be back online shortly. Thank you for your patience.
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center">
          <p className="text-xs text-gray-500">
            TransferPitch Platform - We appreciate your understanding
          </p>
        </div>
      </div>

      {/* Background Pattern */}
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-96 h-96 bg-[#2283FF] rounded-full opacity-5 blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 transform translate-x-1/2 w-64 h-64 bg-blue-300 rounded-full opacity-10 blur-2xl"></div>
      </div>
    </div>
  );
};

export default MaintenanceMode;
